import { render, staticRenderFns } from "./riskVehicle.vue?vue&type=template&id=393d4411&scoped=true"
import script from "./riskVehicle.vue?vue&type=script&lang=js"
export * from "./riskVehicle.vue?vue&type=script&lang=js"
import style0 from "./riskVehicle.vue?vue&type=style&index=0&id=393d4411&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393d4411",
  null
  
)

export default component.exports